import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "Theme/AppTheme";
import { Observer } from "mobx-react";
import React from "react";
import WorkflowReview from "./WorkflowReview";

const WorkflowReviewContainer = () => {
    return (
        <Observer>
            {() => (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <WorkflowReview />
                    </ThemeProvider>
                </StyledEngineProvider>
            )}
        </Observer>
    );
};

export default WorkflowReviewContainer;
